import { useTranslation } from "react-i18next";
import VestelIcon from "../../../atoms/images/VestelIcon";

const IdentityPanel = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="logo-background flex items-center h-full content-center justify-center flex-col">
      <VestelIcon className="flex items-center justify-center content-center" />
      <p className="p-6 flex items-center justify-center content-center text-white text-6xl font-bold text-center">
        {t("layout.vestel-user-management")}
      </p>
      {i18n.language !== "tr" && (
        <p className="flex items-center justify-center content-center text-white text-lg font-medium">
          {t("layout.vestel-user-management-description")}
        </p>
      )}
    </div>
  );
};

export default IdentityPanel;
